export enum WebPushAuthType {
  FIREBASE = 'firebase',
  FIREBASE_JSON = 'firebaseJson',
}

export enum WebPushPlatform {
  FCM = 'FCM',
}

type BaseCreateFormValues = {
  /** The authentication type of the Firebase credentials used for the integration. */
  authType: WebPushAuthType;
  /** Firebase Sender ID. */
  fcmSenderId: string;
  /** Currently we only support FCM as a webPush platform. */
  platform: WebPushPlatform.FCM;
};

type CreateLegacyFormValues = BaseCreateFormValues & {
  /** The authentication type of the Firebase credentials used for the integration. */
  authType: WebPushAuthType.FIREBASE;
  /** Value of the Firebase API key. */
  fcmServerKey: string;
};

type CreateJsonFormValues = BaseCreateFormValues & {
  /** The authentication type of the Firebase credentials used for the integration. */
  authType: WebPushAuthType.FIREBASE_JSON;
  /** Value of the Firebase JSON file (stringified). */
  fcmJson: string;
};

export type CreateWebPushFormValues = CreateLegacyFormValues | CreateJsonFormValues;

/** Web push integration object as fetched from backend. */
export type WebPushIntegration = BaseCreateFormValues & {
  /** The ID of the project associated with this integration. Only 1 integration can exist per project. */
  projectId: number;
  /** Value of the Firebase API key. */
  fcmServerKey?: string;
};

export type TestWebPushFormValues = {
  pushConfig: WebPushIntegration;
  title: string;
  body: string;
  icon: string;
  browserToken: string;
  clickAction: string;
};

export type DeleteWebPushFormValues = {
  platform: WebPushPlatform.FCM;
};

export type WebPushReducerState = {
  integrations: {
    webPushIntegrations: {
      webPushIntegrations: WebPushIntegration[];
      isLoading: boolean;
    };
  };
};
